
import React from 'react';

const CasesHero: React.FC = () => {
  return (
    <section 
      className="relative py-32 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20scientific%20research%20laboratory%20with%20genomics%20equipment%2C%20DNA%20sequencing%20machines%2C%20computer%20workstations%20displaying%20bioinformatics%20data%20analysis%2C%20clean%20professional%20laboratory%20environment%20with%20advanced%20biotechnology%20instruments%20and%20molecular%20biology%20equipment&width=1920&height=800&seq=cases-hero-bg&orientation=landscape')`
      }}
    >
      {/* 浅色蒙层 */}
      <div className="absolute inset-0 bg-gradient-to-r from-white/85 via-blue-50/90 to-indigo-50/85"></div>
      
      {/* 装饰性元素 */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-blue-100/30 rounded-full blur-xl"></div>
      <div className="absolute bottom-20 right-10 w-40 h-40 bg-purple-100/30 rounded-full blur-xl"></div>
      <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-indigo-100/20 rounded-full blur-lg"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <h1 className="text-5xl font-bold mb-6 text-gray-900">
          探索不同研究方向的<strong className="text-blue-600">期刊文章</strong>
        </h1>
        <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed text-gray-700">
          下述文献之研究水准与方法体系，即为本服务所对标的质量标准，可为您的研究提供可靠参考与创新动力
        </p>
      </div>
    </section>
  );
};

export default CasesHero;
